import { render, staticRenderFns } from "./audioAdjust.vue?vue&type=template&id=47bc460d&scoped=true"
import script from "./audioAdjust.vue?vue&type=script&lang=js"
export * from "./audioAdjust.vue?vue&type=script&lang=js"
import style0 from "./audioAdjust.vue?vue&type=style&index=0&id=47bc460d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bc460d",
  null
  
)

export default component.exports